import React from 'react'
import Select from 'react-select'
import { useInternationalization } from '../../features/i18n'
import { FormDashboardLabel as Label } from '../dashboard-form'
import { TagItem } from '../tag-item'

const PartnerSelect = ({ options, selectValue, addItem, data, removeItem }) => {
  const { translate } = useInternationalization()

  return (
    <div>
      <Label>{translate('PARTNER', 'choose')}</Label>
      <div className="lg:w-2/3 mb-5">
        <Select
          options={options}
          placeholder={`${translate('SEARCH', 'search')} ${translate('PARTNER', 'singular')}`}
          className="text-sm"
          value={selectValue}
          onChange={addItem}
        />
      </div>
      <div className="flex flex-wrap">
        {data && data.map((item) => (
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2" key={item.value}>
            <TagItem
              value={item.label}
              onClose={() => removeItem(item.value)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export { PartnerSelect }
